import { createContext, useContext } from 'react';

export interface FeatureFlagContextState {
  isCampaignAnalyticsReactificationEnabled: boolean;
  isInAppRecallUIEnabled: boolean;
  isSuspendSendsEnabled: boolean;
}

export const DEFAULT_FEATURE_FLAG_CONTEXT_STATE: FeatureFlagContextState = {
  isCampaignAnalyticsReactificationEnabled: false,
  isInAppRecallUIEnabled: false,
  isSuspendSendsEnabled: false,
};

export const FeatureFlagContext = createContext<FeatureFlagContextState>(
  DEFAULT_FEATURE_FLAG_CONTEXT_STATE,
);

export const useFeatureFlagContext = () => useContext(FeatureFlagContext);
